// extracted by mini-css-extract-plugin
module.exports = {"logo_link":"logo_logo_link__rc3Sx","logo":"logo_logo__kI7vD"};